import React from 'react'
import loader from '../assets/images/loader.svg'

const Loading = ({style}) => {
  return <img src={loader} style={style} alt='loader' />
}

export default Loading